'use client';

import { AccountEnterpriseAccounts as Section } from '../../components/UserProfile/AccountSections';
import { createSection } from '../createSection';

export const UserProfileEnterpriseAccountsSection = createSection('UserProfileEnterpriseAccountsSection', Section);
